<template>
  <modal>
    <div class="modal__stage">
      <form
        class="form"
        method="POST"
        @submit.prevent="updateOrSave"
      >
        <div class="modal__head">
          <h5>News</h5>
          <button
            type="button"
            class="button button--icon"
            @click.prevent="$store.dispatch('modal/close')"
          >
            <i class="icon icon-e-remove" />
          </button>
        </div>

        <div class="modal__body">
          <div class="modal__panel">
            <div class="modal__block">
              <div class="row">
                <div class="col col--12">
                  <FormText
                    v-model="form.title"
                    name="title"
                    :rules="['required']"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col col--12">
                  <FormTextArea
                    v-model="form.content"
                    :rows="3"
                    name="content"
                    :rules="['required']"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col col--6">
                  <FormDate
                    v-model="form.start_at"
                    name="start_at"
                  />
                </div>
                <div class="col col--6">
                  <FormDate
                    v-model="form.end_at"
                    name="end_at"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal__foot">
          <div class="button-group">
            <ButtonLoader
              :loading="loading"
              class="u-pos-r"
            >
              Save Changes
            </ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import clone from 'lodash/clone'
import Modal from '@components/modals/Modal'
import ButtonLoader from '@components/shared/ButtonLoader'
import FormText from '@components/forms/FormText'
import FormTextArea from '@components/forms/FormTextArea'
import FormDate from '@components/forms/FormDate'

export default {
  name: 'NewsModal',
  components: {
    FormDate,
    FormTextArea,
    FormText,
    ButtonLoader,
    Modal,
  },
  props: {
    news: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data () {
    return {
      loading: false,
      form: this.$inertia.form({
        id: null,
        title: null,
        content: null,
        start_at: null,
        end_at: null,
      }),
    }
  },
  created() {
    if (this.news) {
      this.form = this.$inertia.form(clone(this.news))
    }
  },
  methods: {
    async updateOrSave() {
      await this.news ? this.update() : this.save()

      this.$store.dispatch('modal/close')
    },
    async save () {
      await this.form.post(this.route('news.store'), {
        onStart: () => this.loading = true,
        onFinish: () => this.loading = false,
      })
    },
    async update () {
      await this.form.put(this.route('news.update', this.news.id), {
        onStart: () => this.loading = true,
        onFinish: () => this.loading = false,
      })
    },
  },
}
</script>
